import React from "react";
import { NavLink } from "react-router-dom";

class ShopSidebar extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <div className="side-bar p-a30 bg-gray">
          {/* SEARCH */}
          <div className="widget">
            <h4 className="widget-title ">Recherche</h4>
            <div className="search-bx p-a5 bg-white">
              <form action="#" role="search" method="post">
                <div className="input-group">
                  <input
                    name="news-letter"
                    type="text"
                    className="form-control"
                    placeholder="Rechercher par titre"
                  />
                  <span className="input-group-btn">
                    <button type="button" className="btn">
                      <i className="fa fa-search" />
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>

          {/* NEWSLETTER */}
          <div className="widget widget_newsletter-2">
            <h4 className="widget-title  ">Newsletter</h4>
            <div className="newsletter-bx p-a10 bg-white">
              <div className="newsletter-content">
                <p>
                  Soyez les premiers informés de nos actualités en vous
                  inscrivant à notre newsletter.
                </p>
              </div>
              <div className="m-t20">
                <form action="#" role="search" method="post">
                  <div className="input-group">
                    <input
                      name="news-letter"
                      className="form-control"
                      placeholder="Entrer votre Email"
                      type="text"
                    />
                    <span className="input-group-btn">
                      <button type="button" className="site-button">
                        <i className="fa fa-paper-plane-o" />
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ShopSidebar;
